import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { showAboutThisCourseBottomSheetAction } from "@src/components/BottomSheets/store/actions.js";
import { useTranslation } from "react-i18next";
import Linkify from "linkify-react";
import { hitHapticFeedback } from "@src/utils";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";

function Description({ desc, setShowModal }) {
  const { t } = useTranslation();
  // console.log("calli", desc);
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  const containerRef = useRef();
  const [showReadMore, setShowReadMore] = useState(false);
  const [isOpen, setisOpen] = useState(false);

  const isPurchased = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased
  );

  useEffect(() => {
    // console.log("B______1", desc);
    // console.log("B______1", containerRef?.current);
    // console.log("B______2", containerRef?.current?.clientHeight);
    // console.log("B______3", containerRef?.current?.scrollHeight);
    if (
      containerRef?.current?.clientHeight < containerRef?.current?.scrollHeight
    ) {
      // containerRef.current.classList.add("readMoreEllipsis");
      setShowReadMore(true);
    } else {
      setShowReadMore(false);
      setisOpen(false);
    }
  }, [desc, containerRef?.current?.clientHeight]);

  // useEffect(()=>{
  //   if(isOpen)
  //     return
  //   let {scrollHeight, clientHeight} = containerRef.current
  //   let {scrollTop} = document.scrollingElement

  //   document.scrollingElement.scrollTop = scrollTop + clientHeight - scrollHeight
  // }, [isOpen])

  const linkProps = {
    onClick: (e) => {
      e?.preventDefault();
      hitHapticFeedback();
      hitDeeplinkExecutedV2(
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        }),
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        })
      );
    },
  };

  return (
    <div className={isOpen ? "box open" : "box"}>
      <div
        ref={containerRef}
        // style={{ minHeight: isOpen ? "auto" : "2vh", maxHeight: "14vh" }}
        className={isOpen ? "text open" : "text"}
      >
        {/* kfnjkdn ajsdnf djan fadjs fdajns fjnads fjnds sdh fhdf dsahbkf adsbhkjf
        sahbdf sbahdf hsbad fhbasd fhbdsa fhbsa dfhbsad fhsad fhbsa dfhbads
        fhbdsa fhsad fhbdsa fhbasd fhbsad fhbsad fhiasdbfabfiyhbf saidgh
        fshiagdf aisdgyhf adsihgf aisdhfbasouhdfbasdhf adsuofhasdkjf
        sadhfbuosadfb isajdhf sadhfbasdjfds fhsadbfousadfb sadhf sadhfjsa
        dfkhasdbfjsd fhksda fhsdabfj sadhfb sadkfh sdkhbf sahdf shadf ihsdaf
        sdhf dhsbf dhsif dsihf disfhb sdfghi sdfhs dah */}
        <Linkify options={{ attributes: linkProps }}>{desc}</Linkify>
      </div>
      {showReadMore && (
        <div>
          <div
            className="box__ReadMore"
            onClick={() => dispatch(showAboutThisCourseBottomSheetAction(true))}
          >
            {t(
              "components.tabs.overview.components.Description.readMore",
              "Read More"
            )}
          </div>
        </div>
      )}
    </div>
  );
}
export default React.memo(Description);
